import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Constante } from '../../constante';

export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.isAuthenticated()) {
        return true;
    }
    return router.createUrlTree([Constante.URL_LOGIN]);
};

export const adminGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.isAuthenticated() && auth.isAdmin()) {
        return true;
    }
    if (auth.isAuthenticated()) {
        return router.createUrlTree([Constante.URL_HOME]);
    }
    return router.createUrlTree([Constante.URL_LOGIN]);
};
